import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Images, Logos } from "../../data/Assets";

import SignInView from "../views/auth/SignIn";
import ForgotPasswordView from "../views/auth/ForgotPassword";
import ResetPasswordView from "../views/auth/ResetPassword";
import { ImageAsset } from "../wrappers/ImageAsset";

const AuthPage = () => {
    const { view } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (
            view !== "sign-in" &&
            view !== "forgot-password" &&
            view !== "reset-password" &&
            view !== "set-password"
        ) {
            navigate("/auth/sign-in");
        };

        // eslint-disable-next-line
    }, [view]);

    const getView = () => {
        if (view === "sign-in") return <SignInView />;
        if (view === "forgot-password") return <ForgotPasswordView />;
        if (view === "reset-password" || view === "set-password") return <ResetPasswordView />;
    };

    return (
        <div className="immersion__auth__page_view">
            <div className="immersion__auth_bg__section">
                <ImageAsset src={Logos.Logo} alt="" className="immersion__auth_logo" />
                <ImageAsset src={Images.GlobalTalentStream} alt="" className="immersion__auth_bg1" />
                <ImageAsset src={Images.HappySearch} alt="" className="immersion__auth_bg2" />
                <ImageAsset src={Images.Chart} alt="" className="immersion__auth_bg3" />
            </div>
            <div className="immersion__auth_forms__section">
                {getView()}
            </div>
        </div>
    );
};

export default AuthPage;